<template>
	<div class="template contact select"  v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			
			<div class="input_value" :style="dataVal.Property.Title[0].Text.length == 4?'max-width:calc(100% - 67px);':''">
				<Select v-if='dataVal.Config.Selector.Type=="multi"' v-bind:disabled="dataVal.Disable" :max-tag-count="6" :transfer='true' v-model="dataVal.Value" @on-change="changeVal(dataVal.Property.Title[0].Text,dataVal.Config.Selector.Type)" multiple>
					<Option v-for="item in dataVal.Config.Selector.Options" :value="item.Key" :key="item.Key" v-show="item.IsShow==null||item.IsShow">{{ item.Value[0].Text}}</Option>
				</Select>
				<Select v-if='dataVal.Config.Selector.Type=="single"' v-bind:disabled="dataVal.Disable"  v-model="dataVal.Value" @on-change="changeVal(dataVal.Property.Title[0].Text,dataVal.Config.Selector.Type)">
					<!-- <Option :disabled="item.IsShow!=null&&!item.IsShow"  v-for="item in dataVal.Config.Selector.Options" :value="item.Key" :key="item.Key">{{ item.Value[0].Text}}</Option> -->
					<Option v-for="item in dataVal.Config.Selector.Options" :value="item.Key" :key="item.Key">{{ item.Value[0].Text}}</Option>
				</Select>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			changeVal(name,type) {
				var val=null;
				if(type=="multi"){
					val.push([this.dataVal.Values]);
				}else{
					val=this.dataVal.Value
				}
				this.$emit('child-event', val,name,type,this.dataVal);
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';

	.ivu-select-selection {
		border: none !important;
	}

	.ivu-select-single .ivu-select-selection {
		height: 24px !important;
	}

	.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
	.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
		height: 24px !important;
		line-height: 24px !important;
	}
	.ivu-select-dropdown-list{
		text-align: left !important;
	}
</style>
